var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"gauge-container",style:({ height: _vm.height }),attrs:{"id":_vm.alias,"title":_vm.$t('label_reports_genderGap_indicatorStatus_title')}})
}
var staticRenderFns = []

export { render, staticRenderFns }